import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
 
import LoginPageTranslations from './locales/LoginPage.json';
import FooterTranslations from './locales/Footer.json';
import UsersPageTranslations from './locales/UsersPage.json';
import SearchBarTranslations from './locales/SearchBar.json';
import UsersTableTranslations from './locales/UsersTable.json'
import SettingPageTranslations from './locales/SettingPage.json';;
import LoginCardTranslations from './locales/LoginCard.json';
import LoadingPageAnimationTranslations from './locales/LoadingPageAnimation.json'
import ForbiddenPageTranslations from './locales/ForbiddenPage.json'
import NotFoundPageTranslations from './locales/NotFoundPage.json'
import UserSettingsPageTranslations from './locales/UserSettingsPage.json'
import AdminUserFormCardTranslations from './locales/AdminUserFormCard.json'
import FileCardTranslations from './locales/FileCard.json'
import NavbarTranslations from './locales/Navbar.json'
import LanguageSwitcherTranslations from './locales/LanguageSwitcher.json'
import SideBarTranslations from './locales/SideBar.json'
import UserProjectPageTranslations from './locales/UserProjectPage.json'
import EmailInputTranslations from './locales/EmailInput.json'
import UserModalTranslations from './locales/UserModal.json'
import UsersAttachmentsTranslations from './locales/UsersAttachments.json'
import SearchMessageTranslations from './locales/SearchMessage.json'
import PdfViewTranslations from './locales/PdfView.json'
import FileHeaderTranslations from "./locales/FileHeader.json"
import ResultsViewTranslations from "./locales/ResultsView.json"
import UserProjectsTableTranslations from "./locales/UserProjectsTable.json"
import EndTranscriptionPopupTranslations from "./locales/EndTranscriptionPopup.json"
import SelectedAllCheckboxTranslations from "./locales/SelectedAllCheckbox.json";
import CityViewPageTranslations from "./locales/CityViewPage.json";
import ProjectsPageTranslations from "./locales/ProjectsPage.json";
import CityFilesPageTranslations from "./locales/CityFilesPage.json";
import CityFilesTableTranslations from "./locales/CityFilesTable.json";
import RolesNamesTranslations from "./locales/RolesNames.json";
import CreateProjectPageTranslations from "./locales/CreateProjectPage.json";
import SuperAdminUsersTranslations from "./locales/SuperAdminUsers.json";
import UsersManagementTranslations from "./locales/UsersManagement.json";
import AddUserModalTranslations from "./locales/AddUserModal.json";
import SuperAdminCitiesTranslations from "./locales/SuperAdminCities.json";
import AddCityModalTranslations from "./locales/AddCityModal.json";
import CityInfoTabTranslations from "./locales/CityInfoTab.json";
import GeneralEnergyTabTranslations from "./locales/GeneralEnergyTab.json";
import TransportationTabTranslations from "./locales/TransportationTab.json";
import ElectricityTabTranslations from "./locales/ElectricityTab.json";
import AlternativesPanelTranslations from "./locales/AlternativesPanel.json";
import ProjectHeaderTranslations from "./locales/ProjectHeader.json";
import BackButtonTranslations from "./locales/BackButton.json";
import EnergyContentTranslations from "./locales/EnergyContent.json";
import ElectricityContentTranslations from "./locales/ElectricityContent.json";
import AlternativeDashboardTranslations from "./locales/AlternativeDashboard.json";
import CompareEnergyTranslations from "./locales/CompareEnergy.json";
import CompareElectricityTranslations from "./locales/CompareElectricity.json";
import UpdateAlternativePageTranslations from "./locales/UpdateAlternativePage.json";
import CityParametersManagementPageTranslations from "./locales/CityParametersManagementPage.json";
i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    ns: ['LoginPage', 'Footer',
     'OrganizationSettingPage','OrganizationProjectsTable',
     'ProjectSettingsPage','CreateNewProjectCard','LoginCard',
      'CreateNewOrgCard','OrganizationProjectsTab',
      'ForbiddenPage', 'NewOrganization',
      'NotFoundPage', 'UserSettingsPage',
      'MarketplaceButton', 'NavbarTranslations','ChatFocus',
      'NotFoundPage', 'UserSettingsPage','FileCard','UsersTable','UsersPage',
      'SettingPage','OrganizationSettingsTab','PurchasedCard','ProjectsPage',
      'UserProjectPage', 'PromptCard',
      'ChatInput', 'FilesTable', 'PreviewImageModal',
      'EmailInput', 'UserModal', 'UsersAttachments',
      'SearchRes', 'SearchMessage', 'AudioView', 'PdfView',
      'Sentimental', 'NewTranscriptionPopup', 'SuperAdminUsers', 'UsersManagement', 'AddUserModal',
      'SuperAdminCities', 'AddCityModal', 'RolesNames'
    ],
    defaultNS: 'loginPage',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    resources: {
      en: {
        LoginPage: LoginPageTranslations.en,
        Footer: FooterTranslations.en,
        UsersPage: UsersPageTranslations.en,
        SearchBar: SearchBarTranslations.en,
        UsersTable: UsersTableTranslations.en,
        SettingPage: SettingPageTranslations.en,
        LoginCard: LoginCardTranslations.en,
        LoadingPageAnimation: LoadingPageAnimationTranslations.en,
        ForbiddenPage: ForbiddenPageTranslations.en,
        NotFoundPage: NotFoundPageTranslations.en,
        UserSettingsPage: UserSettingsPageTranslations.en,
        AdminUserFormCard: AdminUserFormCardTranslations.en,
        FileCard: FileCardTranslations.en,
        Navbar: NavbarTranslations.en,
        LanguageSwitcher: LanguageSwitcherTranslations.en,
        SideBar: SideBarTranslations.en,
        UserProjectPage: UserProjectPageTranslations.en,
        EmailInput: EmailInputTranslations.en,
        UserModal: UserModalTranslations.en,
        UsersAttachments: UsersAttachmentsTranslations.en,
        SearchMessage: SearchMessageTranslations.en,
        PdfView: PdfViewTranslations.en,
        FileHeader: FileHeaderTranslations.en,
        ResultView: ResultsViewTranslations.en,
        UserProjectsTable: UserProjectsTableTranslations.en,
        EndTranscriptionPopup: EndTranscriptionPopupTranslations.en,
        SelectedAllCheckbox: SelectedAllCheckboxTranslations.en,
        CityViewPage: CityViewPageTranslations.en,
        ProjectsPage: ProjectsPageTranslations.en,
        CityFilesPage: CityFilesPageTranslations.en,
        CityFilesTable: CityFilesTableTranslations.en,
        RolesNames: RolesNamesTranslations.en,
        CreateProjectPage: CreateProjectPageTranslations.en,
        SuperAdminUsers: SuperAdminUsersTranslations.en,
        UsersManagement: UsersManagementTranslations.en,
        AddUserModal: AddUserModalTranslations.en,
        SuperAdminCities: SuperAdminCitiesTranslations.en,
        AddCityModal: AddCityModalTranslations.en,
        CityInfoTab: CityInfoTabTranslations.en,
        GeneralEnergyTab: GeneralEnergyTabTranslations.en,
        TransportationTab: TransportationTabTranslations.en,
        ElectricityTab: ElectricityTabTranslations.en,
        AlternativesPanel: AlternativesPanelTranslations.en,
        ProjectHeader: ProjectHeaderTranslations.en,
        BackButton: BackButtonTranslations.en,
        EnergyContent: EnergyContentTranslations.en,
        ElectricityContent: ElectricityContentTranslations.en,
        AlternativeDashboard: AlternativeDashboardTranslations.en,
        CompareEnergy: CompareEnergyTranslations.en,
        CompareElectricity: CompareElectricityTranslations.en,
        UpdateAlternativePage: UpdateAlternativePageTranslations.en,
        CityParametersManagementPage: CityParametersManagementPageTranslations.en,
      },
      he: {
        LoginPage: LoginPageTranslations.he,
        Footer: FooterTranslations.he,
        UsersPage: UsersPageTranslations.he,
        SearchBar: SearchBarTranslations.he,
        UsersTable: UsersTableTranslations.he,
        SettingPage: SettingPageTranslations.he,
        LoginCard: LoginCardTranslations.he,
        LoadingPageAnimation: LoadingPageAnimationTranslations.he,
        ForbiddenPage: ForbiddenPageTranslations.he,
        NotFoundPage: NotFoundPageTranslations.he,
        UserSettingsPage: UserSettingsPageTranslations.he,
        AdminUserFormCard: AdminUserFormCardTranslations.he,
        FileCard: FileCardTranslations.he,
        Navbar: NavbarTranslations.he,
        LanguageSwitcher: LanguageSwitcherTranslations.he,
        SideBar: SideBarTranslations.he,
        UserProjectPage: UserProjectPageTranslations.he,
        EmailInput: EmailInputTranslations.he,
        UserModal: UserModalTranslations.he,
        UsersAttachments: UsersAttachmentsTranslations.he,
        SearchMessage: SearchMessageTranslations.he,
        PdfView: PdfViewTranslations.he,
        FileHeader: FileHeaderTranslations.he,
        ResultView: ResultsViewTranslations.he,
        UserProjectsTable: UserProjectsTableTranslations.he,
        EndTranscriptionPopup: EndTranscriptionPopupTranslations.he,
        SelectedAllCheckbox: SelectedAllCheckboxTranslations.he,
        CityViewPage: CityViewPageTranslations.he,
        ProjectsPage: ProjectsPageTranslations.he,
        CityFilesPage: CityFilesPageTranslations.he,
        CityFilesTable: CityFilesTableTranslations.he,
        RolesNames: RolesNamesTranslations.he,
        CreateProjectPage: CreateProjectPageTranslations.he,
        SuperAdminUsers: SuperAdminUsersTranslations.he,
        UsersManagement: UsersManagementTranslations.he,
        AddUserModal: AddUserModalTranslations.he,
        SuperAdminCities: SuperAdminCitiesTranslations.he,
        AddCityModal: AddCityModalTranslations.he,
        CityInfoTab: CityInfoTabTranslations.he,
        GeneralEnergyTab: GeneralEnergyTabTranslations.he,
        TransportationTab: TransportationTabTranslations.he,
        ElectricityTab: ElectricityTabTranslations.he,
        AlternativesPanel: AlternativesPanelTranslations.he,
        ProjectHeader: ProjectHeaderTranslations.he,
        BackButton: BackButtonTranslations.he,
        EnergyContent: EnergyContentTranslations.he,
        ElectricityContent: ElectricityContentTranslations.he,
        AlternativeDashboard: AlternativeDashboardTranslations.he,
        CompareEnergy: CompareEnergyTranslations.he,
        CompareElectricity: CompareElectricityTranslations.he,
        UpdateAlternativePage: UpdateAlternativePageTranslations.he,
        CityParametersManagementPage: CityParametersManagementPageTranslations.he,
      }
    },
  });
 
export default i18next;

